import { render, staticRenderFns } from "./stationAdd.vue?vue&type=template&id=1f52bddb"
import script from "./stationAdd.vue?vue&type=script&lang=js"
export * from "./stationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports